// extracted by mini-css-extract-plugin
export default {"root":"style_root__M4P0L","picture":"style_picture__NN67-","description":"style_description__1A-dz"};